module.exports = __webpack_public_path__ + "static/media/phoneBlue.0ae981d4.svg";